
import { useNavigate, useLocation } from "react-router-dom";
import BoardWritePage from "./BoardWritePage";

export default function BoardWritePageWrapper() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const boardType = params.get("boardType") || "공동게시판";
  return <BoardWritePage boardType={boardType} onClose={() => navigate(-1)} />;

}
